import { Ten } from "./Chart.config";
import ShreeDayTable from "./ShreeDayTable";

const ShreeDay = ({ chartData }) => {
  return <ShreeDayTable staticData={Ten} chartData={chartData} />;
};

export default ShreeDay;
